import React, { useState, useEffect } from "react";
import AppStore from "../../../public/static/images/svg/AppStore.svg";
import PlayStore from "../../../public/static/images/svg/PlayStore.svg";
import UseWindowSize from "../UseWindowSize";
import Button from "./Button";

type StepsComponentProps = {
  img?: string;
  title?: string;
  subtitle?: string;
  steps?: any;
  link?: string;
  url?: string;
  displayMobile?: boolean;
  imgRight?: string;
  showButtonApp?: boolean;
  showButtonCTA?: boolean;
  buttonCTAAction?: () => void;
  children?: any;
  hideImg?: string;
  marginWeb?: string;
  marginMobile?: string;
  marginRightappLeft?: boolean;
  fontSteps?: string;
  bullet?: boolean;
  appStoreLink?: string;
  googlePlayLink?: string;
  showImg?: boolean;
  flexDirection?: string;
  hideMobile?: boolean;
  marginAppLeft?: boolean;
  maxWidth?: string;
  alignText?: boolean;
  textAlignAppRightMobile?: string;
  btnBlack?: boolean;
  marginLeft?: string;
  btnDash?: boolean;
  paddingList?: string;
  marginappright?: string;
  fontWeight?: string;
  fontSizeMobile?: string;
};

export const StepsComponent = ({
  img,
  title,
  subtitle,
  steps,
  link,
  url,
  displayMobile,
  imgRight,
  showButtonApp,
  showButtonCTA,
  buttonCTAAction,
  children,
  hideImg,
  marginWeb,
  marginMobile,
  marginRightappLeft,
  fontSteps,
  bullet,
  appStoreLink,
  googlePlayLink,
  showImg,
  flexDirection,
  hideMobile,
  marginAppLeft,
  maxWidth,
  alignText,
  textAlignAppRightMobile,
  btnBlack,
  marginLeft,
  btnDash,
  paddingList,
  marginappright,
  fontWeight,
  fontSizeMobile
}: StepsComponentProps) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  useEffect(() => {
    setWinSize(width);
  });
  const handleGoogle = () => {
    window.open(googlePlayLink, "_blank");
  };
  const handleAppstore = () => {
    window.open(appStoreLink, "_blank");
  };
  return (
    <div className="steps-component-wrapper">
      <div className="application-terms">
        <div className="application-left">
          <img src={img} />
          {showImg && (
            <div className="special-image">
              <img src={AppStore} onClick={handleAppstore}></img>
              <img src={PlayStore} onClick={handleGoogle}></img>
            </div>
          )}
        </div>
        <div
          className={`application-right ${
            btnBlack ? "application-right-black" : ""
          } ${btnDash ? "application-right-stripes" : ""}`}
        >
          <h2>{title}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: subtitle
            }}
          ></p>
          {children}
          {steps && (
            <div>
              {steps.map((data, key) => {
                return (
                  <p
                    key={key}
                    dangerouslySetInnerHTML={{
                      __html: data
                    }}
                  ></p>
                );
              })}
            </div>
          )}
          {link && <a href={url}>{link}</a>}
          <div className={showButtonApp ? "container-img-download" : "none"}>
            <img src={AppStore} onClick={handleAppstore}></img>
            <img src={PlayStore} onClick={handleGoogle}></img>
          </div>
          {showButtonCTA && (
            <Button
              text="Buka My Home Credit"
              onClick={() => buttonCTAAction()}
              fontSizeMobile="12px"
            />
          )}
          {winSize < 631 && (
            <div className="application-left">
              <img src={imgRight}></img>
            </div>
          )}
        </div>
        {winSize > 630 && imgRight && (
          <div className="application-left">
            <img src={imgRight}></img>
          </div>
        )}
      </div>
      <style jsx>
        {`
          .special-image {
            display: none;
          }
          .none {
            display: none;
          }
          .steps-component-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: ${marginWeb};
          }
          .application-terms {
            max-width: 940px;
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
          .application-terms h2 {
            font-weight: bold;
            text-align: ${alignText ? "center" : ""};
          }
          .application-terms p {
            font-family: ${fontSteps ? fontSteps : "Roboto"};
            font-size: 16px;
            font-weight: ${fontWeight ? fontWeight : ""};
          }
          .application-left {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: ${marginAppLeft ? "0px" : "16px"};
            margin-right: ${marginRightappLeft ? "100px" : ""};
          }
          .container-img-download {
            width: 100%;
            cursor: pointer;
          }
          .container-img-download img {
            margin-right: 30px;
            max-width: 160px;
            margin-top: 10px;
          }
          .application-left img {
            margin-top: -50px;
            max-width: 416px;
            width: 100%;
          }

          .application-right {
            max-width: ${maxWidth ? maxWidth : "380px"};
            width: 100%;
            margin: 0 16px;
          }
          .application-right div {
            counter-reset: terms-counter;
            margin-left: ${marginLeft};
          }
          .application-right h2 {
            font-size: 24px;
          }
          .application-right div p {
            font-family: ${fontSteps ? fontSteps : "Roboto"};
            padding-left: ${paddingList ? paddingList : "50px"};
            position: relative;
          }
          .application-right div p::before {
            counter-increment: terms-counter;
            content: counter(terms-counter);
            border-radius: 50%;
            position: absolute;
            left: 0em;
            padding: 2px 8px;
            margin-right: 37px;
            color: ${bullet ? "var(--color-red)" : "var(--color-white)"};
            text-align: center;
            font-size: 80%;
            background-color: var(--color-red);
          }

          .application-right a {
            color: var(--color-red);
            font-weight: bold;
            font-size: 16px;
            list-style: none;
          }
          .application-right a:hover {
            cursor: pointer;
          }
          .application-right-black div p::before {
            padding: 0px 3px;
            color: black;
            font-size: 5px;
            background-color: black;
            margin-top: 10px;
          }
          .application-right-stripes div p::before {
            padding: 0px 4px;
            color: black;
            font-size: 1px;
            background-color: black;
            margin-top: 13px;
            border-radius: 0;
          }
          @media only screen and (max-width: 630px) {
            .application-right div {
              margin: 0px;
            }
            .application-terms h2 {
              text-align: left;
            }
            .special-image {
              display: flex;
              width: 100%;
              cursor: pointer;
              margin-top: 30px;
              justify-content: center;
            }
            .special-image img {
              max-width: 120px;
              padding: 10px;
            }
            .application-right h2 {
              font-size: 16px;
            }
            .container-img-download {
              justify-content: center;
              align-items: center;
              display: flex;
            }
            .application-right,
            .application-left {
              align-self: center;
              margin: 0px;
            }

            .application-left {
              margin: ${marginappright};
            }
            .container-img-download img {
              display: ${hideMobile};
              width: 40%;
              margin: 0;
              padding: 10px;
            }
            .application-right p {
              font-size: ${fontSizeMobile ? fontSizeMobile : "12px"};
            }
            .application-right div p {
              font-size: 12px;
            }
            .application-right div p::before {
              padding: 2px 7px;
              margin-right: 16px;
              margin-top: 3px;
            }
            .application-right-stripes div p::before {
              padding: 0px 3px;
              margin-right: 16px;
              margin-top: 10px;
            }
            .application-right a {
              font-size: 12px;
            }
            .steps-component-wrapper {
              padding: 0 16px;
              margin: ${marginMobile};
            }
            .application-terms {
              flex-direction: column-reverse;
            }
            .application-left {
              display: ${hideImg};
              flex-direction: ${flexDirection};
            }
            .application-right {
              margin-bottom: 0px;
              text-align: ${textAlignAppRightMobile
                ? textAlignAppRightMobile
                : ""};
            }
            .application-terms .application-left img {
              margin-top: 0px;
              width: 90%;
              display: ${displayMobile ? "none" : ""};
            }
            .application-right-black div p::before {
              padding: 0px 2px;
              margin-top: 8px;
              font-size: 4px;
            }
          }
          @media only screen and (max-width: 739px) {
            .container-img-download img {
              width: 40%;
              margin: 0;
              padding: 10px;
            }
          }
        `}
      </style>
    </div>
  );
};

export const TncComponent = (props) => {
  const { title, steps, img, link, url, withNumbering } = props;
  return (
    <div
      className={`steps-component-wrapper ${
        withNumbering ? "tnc-component-wrapper--with-numbering" : ""
      }`}
    >
      <div className="application-how-to">
        <div className="how-to-left">
          <h2>{title}</h2>
          <div>
            <NumBulList steps={steps} withNumbering={withNumbering} />
          </div>
          {link && (
            <a href={url} target="_blank">
              {link}
            </a>
          )}
        </div>
        <div className="how-to-right">
          <img src={img} />
        </div>
      </div>
      <style jsx>
        {`
          .steps-component-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .application-how-to {
            max-width: 940px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 32px 0px 48px 0px;
          }
          .application-how-to h2 {
            font-weight: bold;
            font-size: 24px;
          }

          .how-to-left {
            max-width: 380px;
            width: 100%;
            margin: 16px;
          }
          .how-to-right {
            display: flex;
            justify-content: center;
            align-items: center;
            max-width: 447px;
            margin: 16px;
          }
          .how-to-right img {
            width: 100%;
          }
          .how-to-left a {
            color: var(--color-red);
            font-weight: bold;
            font-size: 16px;
          }
          .how-to-left a:hover {
            cursor: pointer;
          }
          .tnc-component-wrapper--with-numbering .how-to-left {
            counter-reset: tnc-counter;
          }
          @media only screen and (max-width: 630px) {
            .how-to-right,
            .how-to-left {
              align-self: center;
              margin: 0px;
            }
            .application-how-to {
              flex-direction: column;
              padding: 0px;
            }

            .application-how-to {
              padding-top: 0px;
            }

            .how-to-right {
              margin: 0px;
            }
            .how-to-right img {
              padding: 32px;
              width: 80%;
            }

            .how-to-left h2 {
              font-size: 16px;
            }

            .how-to-left a {
              font-size: 12px;
            }
            .steps-component-wrapper {
              padding: 0 16px;
            }
          }
        `}
      </style>
    </div>
  );
};

export const SantaiTncComponent = (props) => {
  const { title, steps, withNumbering } = props;
  return (
    <div
      className={`steps-component-wrapper ${
        withNumbering ? "tnc-component-wrapper--with-numbering" : ""
      }`}
    >
      <div className="application-how-to">
        <div className="how-to-left">
          <h2>{title}</h2>
          <div>
            <NumBulList steps={steps} withNumbering={withNumbering} />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .steps-component-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .application-how-to {
            max-width: 940px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 32px 0px 10px 0px;
          }
          .application-how-to h2 {
            font-weight: bold;
            font-size: 24px;
            text-align: center;
          }

          .how-to-left {
            width: 100%;
            margin: 16px;
          }

          .how-to-left a {
            color: var(--color-red);
            font-weight: bold;
            font-size: 16px;
          }
          .how-to-left a:hover {
            cursor: pointer;
          }
          .tnc-component-wrapper--with-numbering .how-to-left {
            counter-reset: tnc-counter;
          }
          @media only screen and (max-width: 630px) {
            .how-to-right,
            .how-to-left {
              align-self: center;
              margin: 0px;
            }
            .application-how-to {
              flex-direction: column;
              padding: 0px;
            }

            .application-how-to {
              padding-top: 0px;
            }

            .how-to-left h2 {
              font-size: 16px;
            }

            .how-to-left a {
              font-size: 12px;
            }
            .steps-component-wrapper {
              padding: 0 16px;
            }
          }
        `}
      </style>
    </div>
  );
};

export const NumBulList = ({ steps, withNumbering }) => {
  return (
    <div
      className={`numbul-wrapper ${
        withNumbering ? "numbul-wrapper--with-number" : ""
      }`}
    >
      {steps.map((data, key) => {
        return (
          <div
            className="list-text"
            dangerouslySetInnerHTML={{
              __html: data
            }}
            key={key}
          />
        );
      })}
      <style jsx>{`
        .numbul-wrapper--with-number {
          counter-reset: tnc-counter;
        }
        .list-text {
          font-size: 16px;
        }

        .numbul-wrapper--with-number .list-text {
          position: relative;
          padding-left: 50px;
        }

        .numbul-wrapper--with-number .list-text::before {
          counter-increment: tnc-counter;
          content: counter(tnc-counter);
          border-radius: 50%;
          position: absolute;
          left: 0;
          padding: 2px 8px;
          color: var(--color-white);
          text-align: center;
          font-size: 80%;
          background-color: var(--color-red);
          margin-top: 5px;
        }

        @media only screen and (max-width: 630px) {
          .list-text {
            font-size: 12px;
          }

          .numbul-wrapper--with-number .list-text::before {
            padding: 2px 7px;
          }
        }
      `}</style>
    </div>
  );
};

export const GraySectionComponent = (props) => {
  const {
    title,
    steps,
    children,
    paddingGraySection,
    marginGraySection
  } = props;
  return (
    <div className="gray-wrapper">
      <div className="gray-how-to">
        <h2>{title}</h2>
        {!steps ? children : <NumBulList steps={steps} withNumbering={true} />}
      </div>
      <style jsx>{`
        .gray-wrapper {
          background-color: var(--color-white-soft);
          padding: ${paddingGraySection
            ? paddingGraySection
            : "32px 16px 48px 16px"};
          margin: ${marginGraySection ? marginGraySection : ""};
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .gray-how-to {
          width: 100%;
          max-width: 920px;
        }
        .gray-how-to h2 {
          text-align: center;
        }
        .gray-how-to {
          counter-reset: terms-counter;
        }
        .gray-text {
          position: relative;
          padding: 0 0 0 5em;
        }
        .gray-how-to .gray-text::before {
          counter-increment: terms-counter;
          content: counter(terms-counter);
          border-radius: 50%;
          position: absolute;
          padding: 2px 8px;
          left: 0px;
          margin-right: 37px;
          color: var(--color-white);
          text-align: center;
          font-size: 80%;
          background-color: var(--color-red);
        }
        @media only screen and (max-width: 630px) {
          .gray-how-to .gray-text::before {
            left: 0px;
            padding: 2px 7px;
          }
          .gray-text {
            padding: 0 0 0 4em;
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};
